import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const PhoneCall = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.131 13.869C8.961 12.699 8.079 11.389 7.493 10.06C7.37 9.779 7.442 9.45 7.659 9.233L8.478 8.414C9.149 7.743 9.149 6.794 8.563 6.208L7.39 5.035C6.609 4.254 5.343 4.254 4.562 5.035L3.91 5.686C3.169 6.427 2.86 7.496 3.06 8.556C3.554 11.169 5.072 14.03 7.521 16.479C9.97 18.928 12.831 20.446 15.444 20.94C16.504 21.14 17.573 20.831 18.314 20.09L18.965 19.439C19.746 18.658 19.746 17.392 18.965 16.611L17.792 15.438C17.206 14.852 16.256 14.852 15.671 15.438L14.768 16.342C14.551 16.559 14.222 16.632 13.941 16.508C12.612 15.921 11.301 15.038 10.131 13.869Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.832 2.671C20.129 2.671 21 3.849 21 4.947C21 7.176 17.386 9 17.321 9C17.255 9 13.642 7.176 13.642 4.947C13.642 3.849 14.513 2.67 15.81 2.67C16.552 2.67 17.039 3.028 17.321 3.347C17.603 3.029 18.09 2.671 18.832 2.671Z"
      />
    </svg>
  );
};
